import React from 'react';
import ReactTable from 'react-table'
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';
import { renderToStaticMarkup } from 'react-dom/server';





class ProportionsPage extends React.Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	show:false,
	    }
	    this.renderEditable = this.renderEditable.bind(this)
	}
	
	handleProportionCellBlur = (cellInfo, event) => {
		const data = this.props.rows
		let value =  parseInt(event.target.value)
		isNaN(value) ? value = 0 : ''
		this.props.updateRowsInfo(cellInfo, value, this.props.type)
	}
	handleProportionCellChange = (cellInfo, event) => {
		const data = this.props.rows
		let value =  parseInt(event.target.value)
		this.props.updateRowsInfo(cellInfo, value, this.props.type)
	}
	
	renderEditable(cellInfo) {
	    return (
	      <div>
	        <input 
	        	type="number"
	        	value={this.props.rows[cellInfo.index][cellInfo.column.id]}
				onBlur={(e) =>{this.handleProportionCellBlur(cellInfo, e)}}
				onChange={(e) =>{this.handleProportionCellChange(cellInfo, e)}}
				className="editable-cell"
	      	/>
	      </div>	
	    );
	 }

	cancelDeleteProportions = () => {
	    this.setState({ show: false })
	}

	confirmDelete = () => {
	    this.setState({ show: true})
	}

	deleteProportions = () => {
		this.setState({show: false}, this.props.deleteMethod())
	}

	render() {
		let data  = this.props.rows
		return (
			<div>
				 <SweetAlert
		          	show={this.state.show}
		          	title="Confirmar"
		          	text={renderToStaticMarkup(<h5>¿Eliminar las proporciones?</h5>)}
		          	html
		          	onConfirm={() => this.deleteProportions()}
		          	onCancel = {() => this.cancelDeleteProportions()}
		          	confirmButtonText= 'Eliminar'
		          	cancelButtonText= 'Cancelar'
		          	showCancelButton
		        />
				<div className="flex">
					<h3>Restricciones ministerio tipo {this.props.type}</h3>
				</div>
				<div className='proportions-container'>
			        <ReactTable
			          data={this.props.rows}
			          resizeable={true}
			          columns={[
			            {
			              Header: "Cantidad de horas",
			              accessor: "label",
			              maxWidth: 200,
			              className: 'proportion-cell'
			            },
			            {
			              Header: "Minutos Lectivos",
			              accessor: "academic",
			              maxWidth: 200,
			              className: 'proportion-cell',
			              Cell: this.renderEditable
			            },
			   			{
			              Header: "Minutos Recreo",
			              accessor: "break",
			              maxWidth: 200,
			              className: 'proportion-cell',
			              Cell: this.renderEditable
			            },
			            {
			              Header: "Minutos no Lectivos",
			              accessor: "non_academic",
			              maxWidth: 200,
			              className: 'proportion-cell',
			              Cell: this.renderEditable
			            },
			          ]}
			          defaultPageSize={10}
			          className="-striped -highlight"
			        />

		      	</div>
		      	<div className="flex save-proportions-button-container">
			      	<div className=''>
				      	<button className='btn btn-primary' onClick={() => this.props.updateMethod()}>{this.props.isNew ? 'Crear' : 'Actualizar'}</button>
			      	</div>
			      	<div className='delete-button-proportions-page' style={this.props.isNew ? {display:'none'} : {display:'block'}}>
				      	<button className='btn btn-danger' onClick={() => this.confirmDelete()}>Eliminar</button>
			      	</div>
		      	</div>
		    </div>
      	)
	}

}

export default ProportionsPage


// WEBPACK FOOTER //
// ./src/components/proportions/ProportionsPage.js